import { FormEvent } from "react";

import { Button } from "@ezmid/components-library";
import { Control, FieldErrors, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormInputField } from "../../../components/hookFormComponents/FormInputField";
import {
  Option,
  SelectInputField,
} from "../../../components/hookFormComponents/SelectInputField";
import { TextareaField } from "../../../components/hookFormComponents/TextareaField";
import { Optional } from "../../../enums/types";

type Props<T extends FieldValues> = {
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
  control: Control<T>;
  errors: FieldErrors;
  onSubmit: () => void;
  isSubmitButtonDisabled: boolean;
  planOptions: Option[];
  statusOptions: Option[];
  productOptions: Option[];
  defaultPlanValue: Optional<Option>;
  defaultStatusValue: Optional<Option>;
  defaultProductValue: Optional<Option>;
};

export function SubscriptionPackageDetailForm<T extends FieldValues>({
  handleSubmit,
  control,
  errors,
  onSubmit,
  isSubmitButtonDisabled,
  planOptions,
  statusOptions,
  productOptions,
  defaultPlanValue,
  defaultStatusValue,
  defaultProductValue,
}: Props<T>) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <form onSubmit={handleSubmit} />
      <div className="px-4 pt-4">
        <FormInputField
          name={"name" as any}
          htmlFor="name"
          label={t("table.header.name")}
          id="name"
          type="text"
          control={control}
          error={errors.name}
          placeholder={t("table.header.name")}
        />
        <TextareaField
          name={"description" as any}
          htmlFor="description"
          id="description"
          control={control}
          error={errors.description}
          placeholder={t("table.header.description")}
          label={t("table.header.description")}
        />
        <SelectInputField
          name={"plan" as any}
          label={t("table.header.plan")}
          htmlFor="plan"
          control={control}
          options={planOptions}
          defaultValue={defaultPlanValue}
          error={errors.plan}
        />
        <FormInputField
          name={"duration" as any}
          htmlFor="duration"
          label={t("table.header.duration")}
          id="duration"
          type="number"
          control={control}
          error={errors.duration}
          placeholder={t("table.header.duration")}
        />
        <FormInputField
          name={"credits" as any}
          htmlFor="credits"
          label={t("table.header.credits")}
          id="credits"
          type="number"
          control={control}
          error={errors.credits}
          placeholder={t("table.header.credits")}
        />
        <SelectInputField
          name={"status" as any}
          label={t("table.header.status")}
          htmlFor="status"
          control={control}
          options={statusOptions}
          defaultValue={defaultStatusValue}
          error={errors.status}
        />
        <SelectInputField
          name={"productId" as any}
          label={t("form.product.label")}
          htmlFor="productId"
          control={control}
          options={productOptions}
          defaultValue={defaultProductValue}
          error={errors.productId}
        />
      </div>
      <div className="pb-2 pr-4 flex justify-end">
        <Button onClick={onSubmit} disabled={isSubmitButtonDisabled}>
          {t("button.save")}
        </Button>
      </div>
    </div>
  );
}
